/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./card.vue?vue&type=template&id=43024edc&scoped=true&"
import script from "./card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./card.vue?vue&type=style&index=0&id=43024edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43024edc",
  null
  
)

export default component.exports